import React from "react";
import DashboardPart from "./DashbordPart";
import Volunteer from "../../Images/volunteer.png";

const TotalVolunteer = ({ dashboardTotalInfo }) => {

  return (
    <DashboardPart
      DashboardHeading="Total Volunteer"
      DashboardValue={dashboardTotalInfo?.total_vol}
      Icon={Volunteer}
      style={{
        background: "linear-gradient(to right, #0f2027, #203a43, #2c5364)",
      }}
    />
  );
};

export default TotalVolunteer;
